import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { RotatingLines } from 'react-loader-spinner';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, Link } from "react-router-dom";

function Home() {
  const _ = require("lodash");
  const [data, setData] = useState(null);
  const [month, setMonth] = useState([]);
  const [totalCustomer, setTotalCustomer] = useState([]);
  const [loading, setLoading] = useState(true);
  const [smsCost, setSmsCost] = useState(0);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  const [smsCount, setSmsCount] = useState(null);
  const [finalBillAmount, setFinalBillAmount] = useState(0);
  const [monthBillStatus, setMonthBillStatus] = useState("");
  const [clickStates, setClickStates] = useState({
    totalAmount: false,
    collectedAmount: false,
    balanceAmount: false,
  });
  const totalAreaCount = useState(null) ;
  const [totals, setTotals] = useState({allStaff: 0,unpaid: 0,paid: 0,pay: 0,collected: 0,discount: 0,extraBal: 0,balance: 0,pend: 0,cardCnt:0,collectedTday:0,advTday:0,PmPendTday:0,cmBalTday:0});

  function getCookie(name) {
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies) {
      const [key, value] = cookie.split('=');
      if (key === name) {
        return value;
      }
    }
    return null;
  }
const user = getCookie('user');
const isStaff = getCookie('isStaff') === "true";
const secretId = getCookie('secretId');
if (!user) {
  navigate('/login');
}

// Debug (optional)
console.log("User:", user);
console.log("Is Staff:", isStaff);
console.log("Is secretId:", secretId);

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
    setClickStates({totalAmount: false,
      collectedAmount: false,
      balanceAmount: false})
  }; 
  const handleSmsCountChange = (e) => {
    const count = e.target.value;
    setSmsCount(count);
    setSmsCost((0.15 * count).toFixed(2));
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post("https://node.cabletvpay.in/smsrecharge", {
        user,
        sms_count: smsCount,
        sms_cost: smsCost,
      });
      if (res.data.success) {
        toast.success("SMS Recharged Successfully!");
        setTimeout(() => {
          window.location.reload(); // refreshes the current page
        }, 1500);
      } else {
      toast.error("Something went wrong");
      }
    } catch (err) {
      console.error(err);
      toast.error("Server error");
    }
  };

  const toggleClickView = (key) =>
    setClickStates({ ...clickStates, [key]: !clickStates[key] });
  const fetchUserData = async () => {
    try {
      const response = await axios.post('https://node.cabletvpay.in/home',{user});
      
      if (response.status === 200) {
        
        // console.log(response.data);
        setData(response.data.message);
        setTotalCustomer(response.data.month);
        const newTotals = response.data.month.reduce((acc, row) => ({
          allStaff: acc.allStaff + (row.allStaff || 0),
          unpaid: acc.unpaid + (row.unpaid || 0),
          paid: acc.paid + (row.paid || 0),
          pay: acc.pay + (row.pay || 0),
          collected: acc.collected + (row.collected || 0),
          discount: acc.discount + (row.discount || 0),
          extraBal: acc.extraBal + (row.extraBal || 0),
          balance: acc.balance + (row.balance || 0),
          pend: acc.pend + (row.pend || 0),
          cmBalTday: acc.cmBalTday + (row.cmBalTday || 0),
          PmPendTday: acc.PmPendTday + (row.PmPendTday || 0),
          advTday: acc.advTday + (row.advTday || 0),
          collectedTday: acc.collectedTday + (row.collectedTday || 0),
          cardCnt: acc.cardCnt + (row.cardCnt || 0),
        }), { allStaff: 0, unpaid: 0, paid: 0, pay: 0, collected: 0, discount: 0, extraBal: 0, balance: 0, pend: 0,cardCnt:0,collectedTday:0,advTday:0,PmPendTday:0,cmBalTday:0 });
  
        setTotals(newTotals);
      }
    } catch (err) {
      setError(err.response?.data?.message || "Error fetching data");
      console.log(err);
    } finally {
      setLoading(false);
      
    }
  };
  const totalStaffCustomer = [1]

  async function fetchSmsBalance() {
    try {
      const response = await axios.post("https://node.cabletvpay.in/smsbalance",{user});
      if (response.status === 200) {
        setSmsCount(response.data.total_balance_sms_count);
      }
    } catch (error) {
      console.error("Error fetching SMS balance:", error.response?.data || error.message);
      toast.error("Failed to fetch SMS balance.");
    }
  }

 async function fetchMonthBill() {
  try {
    const response = await axios.post(
      "https://node.cabletvpay.in/monthbill",
      { user }
    );

    if (response.status === 200 && response.data.status) {
      setFinalBillAmount(response.data.data.final_payable_amount || 0);
      setMonthBillStatus(response.data.data.bill_status);
    }

  } catch (error) {
    console.error(
      "Error fetching final bill amount:",
      error.response?.data || error.message
    );
    toast.error("Failed to fetch final bill amount");
  }
}


  useEffect(() => {
    fetchUserData();
    fetchSmsBalance(); // Trigger when component mounts
    fetchMonthBill();
  }, []); // Empty dependency array ensures this runs only once
 if (loading) return (<div className="content-wrapper">
     <div className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>
     <RotatingLines visible={true} height="80" width="80" strokeColor="#007bff" strokeWidth="2" animationDuration="0.75" ariaLabel="rotating-lines-loading" wrapperStyle={{}} wrapperClass=""/>
     </div></div>)
   if (error) return (<div className="content-wrapper">
    <div className="d-flex justify-content-center align-items-center" style={{ height: "73vh" }}>
      <img src="../asset/img/errorPage.jpg" alt="" style={{ height: "20rem" }} />
    </div></div>);
    
  return (

    <div className="content-wrapper" >
      <div className=" pt-1">
        <div className="container-fluid">
          {(
  <div className="row mt-2">
    <div className="col-12">
      <marquee behavior="scroll" direction="left" scrollAmount="6">
        
        {monthBillStatus === "unpaid" && finalBillAmount > 0 ? (
          <>
            <span className="text-danger mr-4 text-bold" style={{ fontSize: "20px" }}>
              Please Clear Your Previous Bill Payment Amount ₹ {finalBillAmount} On/Before 10-{new Date().toLocaleString('en-US', { month: 'short', year: 'numeric' })}
            </span>

            <span className="text-danger mr-4 text-bold" style={{ fontSize: "20px" }}>
              உங்கள் முந்தைய பில் தொகை ₹ {finalBillAmount} ரூபாய் 10-{new Date().toLocaleString('en-US', { month: 'short', year: 'numeric' })} க்குள் செலுத்தவும்.
            </span>

            <span className="text-info mr-4 text-bold" style={{ fontSize: "20px" }}>
              If Any Queries Contact Cable TV Pay - Sales : +91 8124124555 / Support : +91 8428075553
            </span>
          </>
        ) : (
       <span
  className="text-info font-weight-bold"
  style={{ fontSize: "20px" }}
>
  If Any Queries Contact Cable TV Pay - Sales : +91 8124124555 / Support : +91 8428075553
</span>
        )}

      </marquee>
    </div>
  </div>
)}
          <div style={{ position: 'absolute', top: '30px' }}><ToastContainer theme='dark' /></div>
          <div className="row mt-3">
            
            <div className="col-4 py-lg-0 py-1">
              <div className="d-flex justify-content-center" >
                
                <div>
                  <button type="button" className="btn bg-gradient-info elevation-2 border-0" data-toggle="modal" data-target="#exampleModal">
                       SMS Balance - {smsCount !== null ? smsCount : "Loading..."}
                  </button>
                  <div className="modal fade " id="exampleModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true" style={{backdropFilter:"blur(5px)"}}>
                    <div className="modal-dialog modal-dialog-centered ">
                      <div className="modal-content elevation-5">
                        <div className="modal-header bg-gradient-navy">
                          <h4 className="modal-title pt-0 mt-0" id="exampleModalLabel">SMS Recharge</h4>
                          <button type="button" className="close fa-w-1 " data-dismiss="modal" aria-label="Close">
                            <span className="text-white" aria-hidden="true">X</span>
                          </button>
                        </div>
                        <div className="modal-body">
                          <form onSubmit={handleSubmit}>
                            <input type="number" name="smsCount"  value={smsCount} onChange={handleSmsCountChange} className="form-control form-control-navbar" id="smsCount" placeholder="Enter No Of SMS" required /> <br />
                            <input type="number" name="smsCost"   value={smsCost} className="form-control form-control-navbar" id="smsCost" placeholder="Enter SMS Cost" readOnly /><br />
                            <div className="d-flex justify-content-end">
                              <input type="submit" id="recharge" className="btn bg-gradient-success" defaultValue="Recharge" />
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
           
            <div className="col-4 py-lg-0 py-1 ">
         {monthBillStatus === "unpaid" && finalBillAmount > 0 && (
  <div className="d-flex justify-content-end pt-1">
    <div className="text-danger">
      Month Bill : ₹ {finalBillAmount}
    </div>
  </div>
)}

              <div className="d-flex justify-content-lg-end justify-content-center">
                <p className="mt-1"><b className="text-primary">G</b> <i className="text-primary">pay</i> : +91 81241 24555</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div className="">
            
          <div className="row mx-xl-3 ">
            <div className="col-12 col-sm-6 col-md-3 col-xl-3">
              <Link className="info-box mb-3 px-xl-2 bg-gradient-secondary" to={"/allCustomer/all"}>
                <span className="info-box-icon filterBtn bg-navy elevation-1"><i className="fas fa-search" /></span>
                <div className="info-box-content">
                  <span className="info-box-text text-light">Customer Search</span>
                </div>
              </Link>
            </div>
             {!isStaff && (
            <div className="col-12 col-sm-6 col-md-3 col-xl-3">
              <Link className="info-box mb-3 px-xl-2 bg-gradient-secondary" to={'/addCustomer'}>
                <span className="info-box-icon filterBtn bg-navy elevation-1"><i className="fas fa-user-plus" /></span>
                <div className="info-box-content">
                  <span className="info-box-text text-light">Add Customer</span>
                </div>
              </Link>
            </div>)}
            
            <div className="clearfix hidden-md-up" />
            <div className="col-12 col-sm-6 col-md-3 col-xl-3">
              <Link className="info-box mb-3 px-xl-2 bg-gradient-secondary" to="/TodayCollection">
                <span className="info-box-icon filterBtn bg-navy elevation-1 "><i className="fas fa-shopping-cart" /></span>
                <div className="info-box-content">
                  <span className="info-box-text text-light">Today's Collection</span>
                  <span className="info-box-number text-light">{data.todayCollection}</span>
                </div>
              </Link>
            </div>
            <div className="col-12 col-sm-6 col-md-3 col-xl-3">
              <Link className="info-box mb-3 px-xl-2 bg-gradient-secondary" to={"/allCustomer/all"}>
                <span className="info-box-icon filterBtn bg-navy elevation-1 "><i className="px-4 fas fa-history" /></span>
                <div className="info-box-content">
                  <span className="info-box-text text-light">Customer's History</span>
                </div>
              </Link>
            </div>
            <div className="col-12 col-sm-6 col-md-3 col-xl-3">
              <a className="info-box mb-3 px-xl-2 bg-gradient-secondary" href="#">
                <span className="info-box-icon filterBtn bg-navy elevation-1"><i className="fas fa-shopping-cart" /></span>
                <div className="info-box-content">
                  <span className="info-box-text text-light">Add STB Purchase</span>
                </div>
              </a>
            </div>
            <div className="col-12 col-sm-6 col-md-3 col-xl-3">
              <Link className="info-box mb-3 px-xl-2 bg-gradient-secondary" to={"/generalExpense"}>
                <span className="info-box-icon filterBtn bg-navy elevation-1"><i className="fas fa-rupee-sign" /></span>
                <div className="info-box-content">
                  <span className="info-box-text text-light">Add Expense</span>
                </div>
              </Link>  
            </div>
            <div className="col-12 col-sm-6 col-md-3 col-xl-3">
              <a className="info-box mb-3 px-xl-2 bg-gradient-secondary" href="#">
                <span className="info-box-icon filterBtn bg-navy elevation-1"><i className="fas fa-sync" /></span>
                <div className="info-box-content">
                  <span className="info-box-text text-light">STB Replacement</span>
                </div> 
              </a> 
            </div> 
            <div className="col-12 col-sm-6 col-md-3 col-xl-3">
              <a className="info-box mb-3 px-xl-2 bg-gradient-secondary" href="#">
                <span className="info-box-icon filterBtn bg-navy elevation-1"><i className="fas fa-address-card" /></span>
                <div className="info-box-content">
                  <span className="info-box-text text-light">Collection Staffs</span>
                  <span className="info-box-number text-light">{data.totalStaff}</span>
                </div> 
              </a> 
            </div> 
          </div>
          </div>
          <div className={` box ${isVisible ? 'visible' : 'hidden'}`}>
              <div className="row py-3">
                <div className="col-lg-3 col-md-3 col-6 d-flex justify-content-center my-1">
                  <div className='d-flex-column'>
                    <p className='text-muted mb-0'>Total customer</p>
                    <p className='pb-lg-2 text-bold text-info'>{data.totalCustomer.toLocaleString()}</p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-6 d-flex justify-content-center my-1">
                  <div className='d-flex-column'>
                    <p className='text-muted mb-0'>Total amount</p>
                    <p className='pb-lg-2 text-bold text-info' onClick={() => toggleClickView('totalAmount')} style={{ cursor: "pointer" }}>{clickStates.totalAmount ? `₹ ${data.totalAmount.toLocaleString()}` : 'ClickToView'}</p>
                  </div>
                </div>
              {!isStaff && (
  <div className="col-lg-3 col-md-3 col-6 d-flex justify-content-center my-1">
    <div className='d-flex-column'>
      <p className='text-muted mb-0'>Collected amount</p>
      <p
        className='pb-lg-2 text-bold text-info'
        onClick={() => toggleClickView('collectedAmount')}
        style={{ cursor: "pointer" }}
      >
        {clickStates.collectedAmount
          ? `₹ ${data.paidAmount.toLocaleString()}`
          : 'ClickToView'}
      </p>
    </div>
  </div>
)}
             {!isStaff && (
  <div className="col-lg-3 col-md-3 col-6 d-flex justify-content-center my-1">
    <div className='d-flex-column'>
      <p className='text-muted mb-0'>Balance amount</p>
      <p
        className='pb-lg-2 text-bold text-info'
        onClick={() => toggleClickView('balanceAmount')}
        style={{ cursor: "pointer" }}
      >
        {clickStates.balanceAmount
          ? `₹ ${data.balanceAmount.toLocaleString()}`
          : 'ClickToView'}
      </p>
    </div>
  </div>
)}
                <div className="col-lg-3 col-md-3 col-6 d-flex justify-content-center my-1">
                  <div className='d-flex-column'>
                    <Link to='/paidcustomer' className='text-muted mb-0'>Paid customer</Link>
                    <p className='pb-lg-2 text-bold text-info' style={{ cursor: "pointer" }}>{data.paidCount.toLocaleString()}</p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-6 d-flex justify-content-center my-1">
                  <div className='d-flex-column'>
                    <Link to='/unpaidcustomer' className='text-muted mb-0'>UnPaid customer</Link>
                    <p className='pb-lg-2 text-bold text-info' style={{ cursor: "pointer" }}>{data.unpaidCount.toLocaleString()}</p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-6 d-flex justify-content-center my-1">
                  <div className='d-flex-column'>
                    <Link to='/advancePaidCustomer' className='text-muted mb-0'>Advance paid customer</Link>
                    <p className='pb-lg-2 text-bold text-info' style={{ cursor: "pointer" }}>{data.extraPaidCount.toLocaleString()}</p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-6 d-flex justify-content-center my-1">
                  <div className='d-flex-column'>
                    <Link to="/currentMonthGetInfo" className='text-muted mb-0'>CM balance amt Customer</Link>
                    <p className='pb-lg-2 text-bold text-info' style={{ cursor: "pointer" }}>{data.pendingCount.toLocaleString()}</p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-6 d-flex justify-content-center my-1">
                  <div className='d-flex-column'>
                    <Link to="/newCustomer" className='text-muted mb-0'>New customer</Link>
                    <p className='pb-lg-2 text-bold text-info' style={{ cursor: "pointer" }}>{data.newcustomerCount.toLocaleString()}</p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-6 d-flex justify-content-center my-1">
                  <div className='d-flex-column'>
                    <Link to="/reconnectionCustomer" className='text-muted mb-0'>Reconnection</Link>
                    <p className='pb-lg-2 text-bold text-info' style={{ cursor: "pointer" }}>{data.recustomerCount.toLocaleString()}</p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-6 d-flex justify-content-center my-1">
                  <div className='d-flex-column'>
                    <Link to="/shiftingCustomer" className='text-muted mb-0'>Shifting customer</Link>
                    <p className='pb-lg-2 text-bold text-info' style={{ cursor: "pointer" }}>{data.shiftcustomerCount.toLocaleString()}</p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-6 d-flex justify-content-center my-1">
                  <div className='d-flex-column'>
                    <Link to="/freeCustomer"className='text-muted mb-0'>Free connection</Link>
                    <p className='pb-lg-2 text-bold text-info' style={{ cursor: "pointer" }}>{data.freecustomerCount.toLocaleString()}</p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-6 d-flex justify-content-center my-1">
                  <div className='d-flex-column'>
                    <Link to="/activecustomer" className='text-muted mb-0'>Active customers</Link>
                    <p className='pb-lg-2 text-bold text-info' style={{ cursor: "pointer" }}>{data.activecustomerCount.toLocaleString()}</p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-6 d-flex justify-content-center my-1">
                  <div className='d-flex-column'>
                    <Link to="/deactivecustomer" className='text-muted mb-0'>Total Deactive customer</Link>
                    <p className='pb-lg-2 text-bold text-info' style={{ cursor: "pointer" }}>{data.deactivecustomerCount.toLocaleString()}</p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-6 d-flex justify-content-center my-1">
                  <div className='d-flex-column'>
                    <Link to="/CMDeactiveCustomer" className='text-muted mb-0'>Current month Deactive customer</Link>
                    <p className='pb-lg-2 text-bold text-info' style={{ cursor: "pointer" }}>{data.cmdeactivecustomerCount.toLocaleString()}</p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-6 d-flex justify-content-center my-1">
                  <div className='d-flex-column'>
                    <Link to="/PMPaidCustomer" className='text-muted mb-0'>PM paid customer</Link>
                    <p className='pb-lg-2 text-bold text-info' style={{ cursor: "pointer" }}>{data.pmdeactivecustomerCount}</p>
                  </div>
                </div>
            </div>
          </div>
          <div className="d-flex justify-content-center mb-4 pt-0">
            <button id="toggleButton" className="showMore " onClick={toggleVisibility}> {isVisible ? '↑ Hide Details' : '↓ Show Details'}</button>
          </div>
           {!isStaff && ( <div className="card border elevation-4 p-0" style={{boxShadow:"inset 0 0 10px rgba(0, 0, 0, 0.4)",backgroundColor:"#acc8e5"}}>
          <div className="card-header border-0 p-0 m-0" style={{boxShadow:"inset 0 0 10px rgba(0, 0, 0, 0.4)",backgroundColor:"#acc8e5"}}>
            <div className="d-flex justify-content-center">
              <div >
                <h4 className="py-0 text-navy" style={{fontWeight:"500"}}>Today Collection Details</h4>
              </div>
            </div>
          <div className="card-body p-0 m-0" >
            <table id="myTable" className="table table-striped table-bordered table-responsive-md">
              <thead className="bg-gradient-navy" style={{ overflowX: "scroll" }} >
                <tr>
                  <th className='py-3'>Name</th>
                  <th className='py-3'>Card count</th>
                  <th className='py-3'>Collected Amount</th>
                  <th className='py-3'>Advance Amount</th>
                  <th className='py-3'>CM Balance</th> 
                  <th className='py-3'>PM pending</th>
                </tr>
              </thead>
              <tbody className='text-navy bg-light'>
                  {
                      totalCustomer.map((row, index,) => (
                        <tr key={index}>
                          <td className='tableText py-lg-3 text-truncate text-bold text-navy'>{row.name} - {`(${row.areaCode})`}</td>
                          <td className='tableText py-lg-3'>{row.cardCnt}</td>
                          <td className='tableText py-lg-3'>{row.collectedTday.toLocaleString()}</td>
                          <td className='tableText py-lg-3'>{row.advTday.toLocaleString()}</td>
                          <td className='tableText py-lg-3'>{row.cmBalTday.toLocaleString()}</td>
                          <td className='tableText py-lg-3'>{row.PmPendTday.toLocaleString()}</td>
                          
                          
                        </tr>
                      ))}
                    <tr className='bg-gradient-gray'>
                      <td className='py-4'>Total</td>
                      <td className='py-4'>{totals.cardCnt}</td>
                      <td className='py-4'>{totals.collectedTday.toLocaleString()}</td>
                      <td className='py-4'>{totals.advTday.toLocaleString()}</td>
                      <td className='py-4'>{totals.cmBalTday.toLocaleString()}</td>
                      <td className='py-4'>{totals.PmPendTday.toLocaleString()}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>)}
        {!isStaff && (
          <div className="card border elevation-4 p-0 mt-5">
            <div className="card-header border-0 p-0 m-0" style={{boxShadow:"inset 0 0 10px rgba(0, 0, 0, 0.4)",backgroundColor:"rgba(51, 158, 204,0.6)"}}>
              <div className="d-flex justify-content-center">
                <div >
                  <h4 className="py-0 text-light" style={{textShadow: "2px 2px 5px rgba(0, 0, 0, 1)"}}>Current Month Collection Details</h4>
                </div>
            </div>
          <div className="card-body p-0 m-0" >
            <table id="myTable" className="table table-striped table-bordered table-responsive-lg">
              <thead className="bg-gradient-navy" style={{ overflowX: "scroll" }} >
                <tr>
                  <th className='py-3'>Name</th>
                  <th className='py-3'>Total Customers</th>
                  <th className='py-3'>Unpaid Customers</th>
                  <th className='py-3'>Paid Customers </th>
                  <th className='py-3'>Pay Amount</th>
                  <th className='py-3'>Collected Amount</th> 
                  <th className='py-3'>Discount Amount</th>
                  <th className='py-3'>Advance Amount</th>
                  <th className='py-3'>CM Balance</th>
                  <th className='py-3'>PM Pending</th>
                </tr>
              </thead>
              <tbody className='text-navy bg-light'>
                    {totalCustomer.map((row, index,) => (
                        <tr key={index}>
                          <td className='tableText py-lg-3 text-truncate text-bold text-navy'>{row.name} - {`(${row.areaCode})`}</td>
                          <td className='tableText py-lg-3'>{row.allStaff.toLocaleString()}</td>
                          <td className='tableText py-lg-3'>{row.unpaid.toLocaleString()}</td>
                          <td className='tableText py-lg-3'>{row.paid.toLocaleString()}</td>
                          <td className='tableText py-lg-3'>{row.pay.toLocaleString()}</td>
                          <td className='tableText py-lg-3'>{row.collected.toLocaleString()}</td>
                          <td className='tableText py-lg-3'>{row.discount.toLocaleString()}</td>
                          <td className='tableText py-lg-3'>{row.extraBal.toLocaleString()}</td>
                          <td className='tableText py-lg-3'>{row.balance.toLocaleString()}</td>
                          <td className='tableText py-lg-3'>{row.pend.toLocaleString()}</td>
                        </tr>
                      ))}
                    <tr className='bg-gradient-gray text-bold text-light'>
                      <td className='py-4'>Total</td>
                      <td className='py-4'>{totals.allStaff.toLocaleString().toLocaleString()}</td>
                      <td className='py-4'>{totals.unpaid.toLocaleString().toLocaleString()}</td>
                      <td className='py-4'>{totals.paid.toLocaleString().toLocaleString()}</td>
                      <td className='py-4'>{totals.pay.toLocaleString().toLocaleString()}</td>
                      <td className='py-4'>{totals.collected.toLocaleString().toLocaleString()}</td>
                      <td className='py-4'>{totals.discount.toLocaleString().toLocaleString()}</td>
                      <td className='py-4'>{totals.extraBal.toLocaleString().toLocaleString()}</td>
                      <td className='py-4'>{totals.balance.toLocaleString().toLocaleString()}</td>
                      <td className='py-4'>{totals.pend.toLocaleString().toLocaleString()}</td>
                    </tr>
                  </tbody>
                </table>
          </div>
          </div>
        </div>)}
        </div>
      </section>
    </div>
  );
}

export default Home;
